import './offer-root-card.css';
